import { render, staticRenderFns } from "./color-exterior-list-item.vue?vue&type=template&id=f28f16ea&scoped=true"
import script from "./color-exterior-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-exterior-list-item.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./color-exterior-list-item.vue?vue&type=style&index=0&id=f28f16ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28f16ea",
  null
  
)

export default component.exports